import { render } from "./Sidebar-SuperAdmin.vue?vue&type=template&id=8a813240&scoped=true"
import script from "./Sidebar-SuperAdmin.vue?vue&type=script&lang=js"
export * from "./Sidebar-SuperAdmin.vue?vue&type=script&lang=js"

import "./Sidebar-SuperAdmin.vue?vue&type=style&index=0&id=8a813240&scoped=true&lang=css"
import "./Sidebar-SuperAdmin.vue?vue&type=style&index=1&id=8a813240&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a813240"]])

export default __exports__